import { LongestTripDuration, TravelDestination, TravelInsuranceRange, TravelInsuranceType, TravelSportActivities } from "../apiGraphql/types/types";
import { LongestTripDurationEnum, TravelDestinationEnum, TravelInsuranceRangeEnum, TravelInsuranceTypeEnum, TravelSportActivitiesEnum } from "../enums";

// Helper function to convert form enum values to GraphQL enum keys
export const convertInsuranceType = (formValue: string): TravelInsuranceType => {
  switch (formValue) {
    case TravelInsuranceTypeEnum.SINGLE:
      return TravelInsuranceType.Single;
    case TravelInsuranceTypeEnum.YEAR:
      return TravelInsuranceType.Year;
    default:
      return TravelInsuranceType.Single;
  }
};

export const convertTravelDestination = (formValue: string): TravelDestination => {
  switch (formValue) {
    case TravelDestinationEnum.EUROPE:
      return TravelDestination.Europe;
    case TravelDestinationEnum.WORLD:
      return TravelDestination.World;
    default:
      return TravelDestination.Europe;
  }
};

// Helper function to convert GraphQL enum values back to form enum values
export const convertInsuranceTypeBack = (graphqlValue?: string): TravelInsuranceTypeEnum => {
  switch (graphqlValue) {
    case TravelInsuranceType.Single:
      return TravelInsuranceTypeEnum.SINGLE;
    case TravelInsuranceType.Year:
      return TravelInsuranceTypeEnum.YEAR;
    default:
      return TravelInsuranceTypeEnum.SINGLE;
  }
};

export const convertTravelDestinationBack = (graphqlValue?: string): TravelDestinationEnum => {
  switch (graphqlValue) {
    case TravelDestination.Europe:
      return TravelDestinationEnum.EUROPE;
    case TravelDestination.World:
      return TravelDestinationEnum.WORLD;
    default:
      return TravelDestinationEnum.EUROPE;
  }
};

export const convertTravelInsuranceRange = (formValue: string): TravelInsuranceRange => {
  switch (formValue) {
    case TravelInsuranceRangeEnum.TEN_TWENTY:
      return TravelInsuranceRange.TenTwenty;
    case TravelInsuranceRangeEnum.TWENTY_FORTHY:
      return TravelInsuranceRange.TwentyForthy;
    case TravelInsuranceRangeEnum.FORTHY_TO_SIXTY:
      return TravelInsuranceRange.ForthyToSixty;
    case TravelInsuranceRangeEnum.MORE_THAN_SIXTY:
      return TravelInsuranceRange.MoreThanSixty;
    default:
      return TravelInsuranceRange.TenTwenty;
  }
};

export const convertTravelInsuranceRangeBack = (graphqlValue?: string): TravelInsuranceRangeEnum => {
  switch (graphqlValue) {
    case TravelInsuranceRange.TenTwenty:
      return TravelInsuranceRangeEnum.TEN_TWENTY;
    case TravelInsuranceRange.TwentyForthy:
      return TravelInsuranceRangeEnum.TWENTY_FORTHY;
    case TravelInsuranceRange.ForthyToSixty:
      return TravelInsuranceRangeEnum.FORTHY_TO_SIXTY;
    case TravelInsuranceRange.MoreThanSixty:
      return TravelInsuranceRangeEnum.MORE_THAN_SIXTY;
    default:
      return TravelInsuranceRangeEnum.TEN_TWENTY;
  }
};

export const convertTravelSportActivities = (formValue: string): TravelSportActivities => {
  switch (formValue) {
    case TravelSportActivitiesEnum.AMATEUR:
      return TravelSportActivities.Amateur;
    case TravelSportActivitiesEnum.PROFESSIONAL:
      return TravelSportActivities.Professional;
    case TravelSportActivitiesEnum.NONE:
      return TravelSportActivities.None;
    default:
      return TravelSportActivities.None;
  }
};

export const convertTravelSportActivitiesBack = (graphqlValue?: string): TravelSportActivitiesEnum => {
  switch (graphqlValue) {
    case TravelSportActivities.Amateur:
      return TravelSportActivitiesEnum.AMATEUR;
    case TravelSportActivities.Professional:
      return TravelSportActivitiesEnum.PROFESSIONAL;
    case TravelSportActivities.None:
      return TravelSportActivitiesEnum.NONE;
    default:
      return TravelSportActivitiesEnum.NONE;
  }
};
  

export const convertLongestTripDuration = (formValue: string): LongestTripDuration => {
  switch (formValue) {
    case LongestTripDurationEnum.LESS_THAN_THREE_MONTHS:
      return LongestTripDuration.LessThanThreeMonths;
    case LongestTripDurationEnum.MORE_THAN_THREE_MONTHS:
      return LongestTripDuration.MoreThanThreeMonths;
    default:
      return LongestTripDuration.LessThanThreeMonths;
  }
};

export const convertLongestTripDurationBack = (graphqlValue?: string | null): LongestTripDurationEnum => {
  switch (graphqlValue) {
    case LongestTripDuration.LessThanThreeMonths:
      return LongestTripDurationEnum.LESS_THAN_THREE_MONTHS;
    case LongestTripDuration.MoreThanThreeMonths:
      return LongestTripDurationEnum.MORE_THAN_THREE_MONTHS;
    default:
      return LongestTripDurationEnum.LESS_THAN_THREE_MONTHS;
  }
};